import React, {Component} from 'react';

import _ from 'lodash';
import moment from 'moment';

import ChartBoxHeader from './chartBoxHeader/chartBoxHeader';
import { dateFormat2Show } from '../../../helpers/dataTransformers';

export default class ChartBox extends Component {

    convertCordinates = (lat, lon) => {
        let latConv = '', lonConv = '';
        if (lat.substr(0,1)==='-') {
            latConv=`${lat.substr(1,2)}°${lat.substr(4,2)}' S`;
        } else {
            latConv=`${lat.substr(0,2)}°${lat.substr(3,2)}' N`;;
        }
        if (lon.substr(0,1)==='-') {
            lonConv=`${lon.substr(1,2)}°${lon.substr(4,2)}' W`;
        } else {
            lonConv=`${lon.substr(0,2)}°${lon.substr(3,2)}' E`;;
        }

        return `${latConv} ${lonConv}`
    }

    toggleBox = () => {
        const { toggleExpand } = this.props;
        toggleExpand();
    }

    renderMonths = (data, months) => {
        const { expanded } = this.props;
        let listItems = [];
        for (const i in months) {
            const monthList = data[months[i]].map((item, index) => (
                <li key={index} className="transits__month--day">
                    <span style={{flexDirection:'row'}}>
                        <span>{item.day.substr(8,2)} - </span>
                        <b className={`morinus-${item.planet1.toLowerCase()}`}/>
                        <b className={`morinus-${item.planet1_sign.toLowerCase()}`}/>
                        <b className={`morinus-${item.transit.toLowerCase()}`}/>
                        <b className={`morinus-${item.planet2.toLowerCase()}`}/>
                        <b className={`morinus-${item.planet2_sign.toLowerCase()}`}/>
                    </span>
                </li>
            ));
            const nameMonth = moment(months[i], 'MM').format('MMMM')
            const month = (
                <div key={i} className={expanded ? "transits__month transits__month-expanded" : "transits__month"}>
                    <h2 className="transits__month--title">{nameMonth}</h2>
                    <ul className={expanded ? "transits__month--body transits__month--body-expanded" : "transits__month--body"}>
                        {monthList}
                    </ul>
                </div>
            )
            if( monthList.length > 0) {
                listItems = listItems.concat(month);    
            }
        }
        return listItems
    }
    
    renderTableTransits = (item) => {
        const { expanded } = this.props;
        const months = {
            "01": [], "02": [], "03": [], "04": [], "05": [], "06": [],
            "07": [], "08": [], "09": [], "10": [], "11": [], "12": []
        }
        for (const i in item) {
            if (!_.isUndefined(item[i].day)) {
                months[item[i].day.substr(5,2)].push(item[i])
            }
        }
    
        let monthArray = (
            expanded ?
                ['01','02','03','04','05','06','07','08','09','10','11','12']
            :
                ['01','02','03','04','05','06']
        )
        return (
                expanded ? 
                <div>
                    <div className={expanded ? "transits transits-expanded" : "transits"}>
                        {this.renderMonths(months, monthArray)}
                    </div>
                </div>
                :
                <div className={expanded ? "transits transits-expanded" : "transits"}>
                    {this.renderMonths(months, monthArray)}
                </div>
        );
    }

    renderChart = () => {
        const { expanded, item } = this.props;
        if (!expanded) {
            return (
                <img
                    className="chart-box--content__img-chart"
                    src={item.chart_image}
                    alt="Mapa Astral"
                />
            )
        }
        return (
            <React.Fragment>
                <img
                    className="chart-box--content__img-chart"
                    src={item.chart_image}
                    alt="Mapa Astral"
                />
                <img
                    className="chart-box--content__img-aspects"
                    src={item.aspects_image}
                    alt="Tabela de aspectos"
                />
            </React.Fragment>
        )
    }

    renderTextFooter = () => {
        const { chartType, expanded } = this.props;
        let text = '';
        let status = '';

        if (expanded) {
            status = 'Fechar'
        } else {
            status = 'Ver'
        }

        if(chartType === 'transito') {
            text = 'Trânsitos'
        } else {
            text = 'Aspectos'
        }

        return status + ' ' + text;
    }

    renderSubtitle = () => {
        const { item, chartType } = this.props;
        if( chartType === "solar" || chartType === "lunar") {
            return (
                <h3  className="title-15" style={{textAlign: 'center'}}>
                    {item.data.returnCity.name}, {item.data.returnCity.state ? item.data.returnCity.state.name : ''} - {item.data.returnCity.country_letters} {this.convertCordinates(item.data.returnCity.lat,item.data.returnCity.lon)} UTC {parseInt(item.data.returnCity.timezone)}<br/> {dateFormat2Show(item.data.dateReturn.date, '/')} {item.data.dateReturn.hour}
                </h3>
            );
        } else if (chartType === "transito") {
            return (
                <h3  className="title-15" style={{textAlign: 'center'}}>
                    {item.data.city.name}, {item.data.city.state ? item.data.city.state.name : ''} - {item.data.city.country_letters} {this.convertCordinates(item.data.city.lat,item.data.city.lon)} UTC {parseInt(item.data.city.timezone)}
                </h3>
            );
        } else {
            return null;
        }
    }

    render() {
        const {
            item, birth, chartType, expanded, chartNumber,
            solarModal, moonModal, transitsModal, backToNatal, chartModal,
            chartPrint
        } = this.props;
        return (
            <div className={`chart-box ${expanded ? 'chart-box--expanded': ''}`}>
                <ChartBoxHeader
                    chartNumber={chartNumber}
                    chartType={chartType}
                    solarModal={solarModal}
                    moonModal={moonModal}
                    transitsModal={transitsModal}
                    backToNatal={backToNatal}
                    chartModal={chartModal}
                    chartPrint={chartPrint}
                />
                <div className="chart-box--content">
                    <div className="chart-box--content-info">
                        <div className="margin-left-small">
                            <h3 className="title-15" >
                                {item.data.person_name}
                            </h3>
                            <h3 className="title-15" >
                                {item.data.name}
                            </h3>
                            <h3 className="title-15">
                                {dateFormat2Show(item.data.birthday, '/')} {item.data.hour}
                            </h3>
                            <h3 className="title-15">
                                {birth.city.name}, {birth.city.state ? birth.city.state.name : ''} - {birth.city.country_letters}
                            </h3>
                            <h3 className="title-15" >
                                {this.convertCordinates(birth.city.lat,birth.city.lon)} UTC {parseInt(birth.city.timezone)}
                            </h3>
                        </div>

                        <div style={{width: '100%', padding:'0 1rem'}}>
                            <h3 className='title-20' style={{textAlign: 'center'}}>{item.data.type}</h3>
                            {chartType !== "natal" ? (
                                <div>
                                    {this.renderSubtitle()}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {chartType === 'transito' ? this.renderTableTransits(item) : this.renderChart()}
                </div>
                <div className="chart-box--footer" onClick={this.toggleBox}>
                    <span>{this.renderTextFooter()}</span>
                </div>
            </div>
        );
    }
}